import { render, staticRenderFns } from "./OsSearchField.vue?vue&type=template&id=8f87f7f2&scoped=true"
import script from "./OsSearchField.vue?vue&type=script&lang=ts"
export * from "./OsSearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f87f7f2",
  null
  
)

export default component.exports